export default __webpack_public_path__ + "static/media/story_otomo-3.8a471dbf.png";